import React, { Component,useState, useEffect,useRef, useLayoutEffect } from "react";
import './App.css';
import './Additional.css'
import Blog from './Blog/Blog.js'

const tagArray = {de:['grammatik', 'redemittel', 'medizin'], _d:['general']}

function App() {

  const [menuCss, setMenuCss] = useState('');
  const [title, setTitle] = useState('Blog')
  const [article, setArticle] = useState(window.liveDangerously? true:false)
  const [blogLanguage, setblogLanguage] = useState(window.blogLanguage)
  const [arrayOfArticles, setArrayOfArticles] = useState(window.arrayOfArticles ? JSON.parse(window.arrayOfArticles):{})
  const [tagFilter, setTagFilter] = useState('')

  useEffect(() => {
      let learn = localStorage.getItem('learn')
      let know = localStorage.getItem('know')

      if(!learn){
        localStorage.setItem('learn', 'de')
      }
      if(!know){
        localStorage.setItem('know', 'en')
      }
  },[])


  function settingTag(x){
    if(x !==tagFilter){
      setTagFilter(x)
    } else {
      setTagFilter('')
    }

  }
 
  let tagItems = tagArray[window.blogLanguage].map((todo, index) => 
<div key={todo} onClick={()=>settingTag(todo)} style={{cursor: 'pointer',marginBottom: '1rem',marginLeft: index !== 0? '2.5%':0 ,padding:'0.5rem', backgroundColor:  tagFilter !== todo? '#00b7ff':'green', boxShadow: '5px 10px 18px rgba(0,0,0,.6)',width:'110px',
  display:'flex', justifyContent:'center',alignItems:'center', flexDirection:'column', fontWeight:'900', color:'white', borderRadius:'10px'
 }}>
     <img  width='50' src={'/images/blog/icons/'+todo+'.png'}></img>
{todo.charAt(0).toUpperCase() +todo.substr(1).toLowerCase()}</div>
  
  )
  
 
  let todoItems  
  if(arrayOfArticles.length){
    todoItems =  arrayOfArticles.map((todo, index) => 

    todo.tags.includes(tagFilter) ? <div class="blog-card" style={{cursor: 'pointer'}}  key={index} onClick={()=>window.location=todo.href}>
           <header>
           <h2>{todo.b}</h2>
           <p>{todo.a}</p>
           </header>

           <img class="blog-img" src={todo.img+'.jpg'}></img>
           <a href={todo.href} style={{color:'white', padding:0}}>Read</a>
     </div>:<div class="" style={{height:0, width:0,overflow:'hidden', padding:0}} key={index} >
           <header >
           <h2>{todo.b}</h2>
           <p>{todo.a}</p>
           </header>

           <img class="blog-img"  src={todo.img+'.jpg'}></img>
           <a href={todo.href}>Read</a>
     </div>

);
  }


  return (
    <div>
    <div className="App" className="notranslate">
       	<header id="header" className="alt">
				<div className="logo"><a href="/"><img class="menu-logo-img" height="45" src='/images/duologo.png'></img> <span> {title}</span></a></div>
        <div style={{display:'flex', flexDirection:'row', float:"right", margin:0, padding:0}}>
      
      <span onClick={()=>window.location = '/profile'} style={{cursor:'pointer', padding:0, margin:0, backgroundColor:'#8080805d', height:'45px', marginTop:'2px', borderRadius:5}}>
      
      <img width={50} style={{padding:0,paddingLeft:3, paddingRight:3}} src= {`https://www.countryflags.io/${localStorage.getItem('learn') ==='en' ?'gb':localStorage.getItem('learn') ==='ko' ?'kr':localStorage.getItem('learn')}/flat/64.png`}></img>

      <img width={50} style={{padding:0,paddingLeft:3, paddingRight:3}} src= {`https://www.countryflags.io/${localStorage.getItem('know') ==='en' ?'gb':localStorage.getItem('know') ==='ko' ?'kr':localStorage.getItem('know')}/flat/64.png`}></img>

      </span>
      


        </div>
			</header>
 
    </div>
    {article ?  <Blog></Blog>:null }
  {blogLanguage && !article ?  <div>
        

	          <div class="blog-cards">
            <div  style={{width:'95%',display:'flex', justifyContent:'center', flexDirection:'row', flexWrap:'wrap'}}>
           
            
                {tagItems}
           
            </div>

						{todoItems}

                  </div>

  
  </div>:null }
  
  
  {!blogLanguage && !article ?  <div>Select Language</div>:null }
    
    </div>
  );
}

export default App;
